
import { isBefore, isValid, parseISO, format } from 'date-fns'
import { mapMutations, mapState } from 'vuex'

export default {
    props: {
        event: {
            type: Object,
            default: () => {
                return {}
            },
        },
        events: {
            type: Array,
            default: () => {
                return []
            },
        },
        isInModal: Boolean,
        isPosse: Boolean,
        fields: {
            type: Array,
            default: () => {
                return ['type', 'name', 'date', 'location', 'guest_count', 'budget', 'is_digital_invitation', 'buttons']
            },
        },
    },

    data() {
        return {
            model: {},
            showCheckBoxes: true,
            showSelect: true,
        }
    },

    computed: {
        ...mapState({
            user: (state) => state.auth.user || {},
            taxonomies: (state) => state.data.taxonomies || [],
        }),

        apiEndpoint() {
            return this.isPosse ? `/api/v1/user-posses/user/${this.$route.params.user}/guest_wedding_events/` : '/api/v1/guest_wedding_events/'
        },

        eventOptions() {
            const events = this.events?.length
                ? this.taxonomies?.events.filter((event) => this.events.findIndex((el) => event.name === el.name) === -1)
                : this.taxonomies?.events
            if (this.eventType?.id) events.push(this.eventType)
            return events
        },

        eventType() {
            return this.model?.taxonomy_event?.data || {}
        },

        date: {
            get() {
                return this.model?.date ? format(parseISO(this.model.date.replace(/Z/, '')), 'yyyy-MM-dd HH:mm') : null
            },
            set(val) {
                this.$set(this.model, 'date', val ? format(val, 'yyyy-MM-dd HH:mm:ss') : null)
                if (isValid(parseISO(this.model.date)) && isBefore(parseISO(this.model.date), new Date()))
                    this.$toast.error('This date is in the past').goAway(3000)
            },
        },

        budget: {
            get() {
                return this.model?.budget || null
            },

            set(val) {
                this.model.budget = val.replace(',', '').replace('$', '')
            },
        },
    },

    watch: {
        event: {
            handler() {
                this.model = { ...this.event }
            },
            immediate: true,
        },
    },

    mounted() {
        this.$store.subscribe((m) => {
            if (m && m.type === 'confirmation/accept') {
                if (m.payload?.action === 'deleteEvent' && m.payload?.params?.id === this.event.id) {
                    this.$axios.$delete('/api/v1/guest_wedding_events/' + this.event.id).then(() => {
                        this.setConfirmationData({})
                        this.saveEventsToUser(null, this.event.taxonomy_event_id)
                        this.$emit('deleted')
                        this.$emit('close')
                    })
                }
            }
        })
    },

    methods: {
        ...mapMutations({
            setConfirmationData: 'confirmation/setConfirmationData',
        }),

        deleteEvent() {
            this.setConfirmationData({
                title: 'Delete event?',
                text: 'You won’t be able to get it back',
                acceptButtonLabel: 'Delete Event',
                action: 'deleteEvent',
                params: {
                    id: this.event.id,
                },
            })
        },

        save() {
            if (this.event.id) {
                if (!this.model.name || this.model.name === '') return
                this.$axios.$put(`${this.apiEndpoint}${this.event.id}`, this.model).then((res) => {
                    this.saveEventsToUser(res.data.taxonomy_event_id)
                    this.$emit('updated', res.data)
                    this.$emit('close')
                })
            } else {
                if (this.isPosse) return
                if (!this.model.name || this.model.name === '') return
                this.$axios.$post('/api/v1/guest_wedding_events', this.model).then((res) => {
                    if (res?.data) {
                        this.$emit('created', res.data)
                        this.saveEventsToUser(res.data.taxonomy_event_id)
                    } else this.$toast.error('Duplicate Event').goAway(3000)
                    this.$emit('close')
                })
            }
        },

        setTaxonomyEventId(val) {
            this.model.taxonomy_event_id = parseInt(val)
            if (!this.model.name) this.model.name = this.eventOptions.find((el) => el.id === parseInt(val))?.name
        },

        setInvitationCheckbox(val) {
            this.model.is_digital_invitation = val
            this.showCheckBoxes = false
            this.$nextTick(() => (this.showCheckBoxes = true))
        },

        saveEventsToUser(addedEvent = null, removedEvent = null) {
            if ((!addedEvent && !removedEvent) || this.isPosse) return
            const model = JSON.parse(JSON.stringify(this.user))
            const weddingDetails = model.wedding_details || {}
            if (!weddingDetails.events) weddingDetails.events = []

            if (addedEvent) {
                const idx = weddingDetails.events.indexOf(addedEvent)
                if (idx === -1) weddingDetails.events.push(addedEvent)
            }

            if (removedEvent) {
                const idx = weddingDetails.events.indexOf(removedEvent)
                if (idx !== -1) weddingDetails.events.splice(idx, 1)
            }

            this.$set(model, 'wedding_details', weddingDetails)

            this.$store.dispatch('user/update', model)
        },

        negativeNumberHandler(key) {
            if (this.model[key] < 0) this.$set(this.model, key, 0)
        },

        handleNameInput() {
            if (this.model.name && !this.model.taxonomy_event_id) {
                const eventType = this.eventOptions.find((el) => el.name === this.model.name)
                if (eventType) {
                    this.showSelect = false
                    this.model.taxonomy_event_id = eventType.id
                    this.$nextTick(() => (this.showSelect = true))
                }
            }
        },

        showField(field) {
            return this.fields.includes(field)
        },
    },
}
